/* global Swiper */
// *******************************************************************************
// 1.0 - Hero Slider
// *******************************************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  window.slideModuleSliderElements = document.querySelectorAll('[data-slider="slide-module-slider"]');

  window.sliderOptions = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    speed: 800,
    watchOverflow: true,
    mousewheel: true,
    releaseOnEdges: true,
    breakpoints: {
      580: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1023: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1199: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
    },
  };

  slideModuleSliderElements.forEach((el) => {
    // eslint-disable-next-line no-new
    new Swiper(el, sliderOptions);
  });
});
